import script from "./LandingPageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingPageHeader.vue?vue&type=script&setup=true&lang=js"

import "./LandingPageHeader.vue?vue&type=style&index=0&id=e4d52bba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4d52bba"]])

export default __exports__